var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import { currMonthDefaultDate } from "../../helper/defaultDate";
import PurchaseReportForUpperSupService from '../../api/PurchaseReportForUpperSupService';
import Header from "./components/Header.vue";
var EDimension;
(function (EDimension) {
    EDimension[EDimension["Depot"] = 3] = "Depot";
    EDimension[EDimension["Organ"] = 2] = "Organ";
    EDimension[EDimension["SupUpper"] = 1] = "SupUpper";
    EDimension[EDimension["Goods"] = 4] = "Goods";
})(EDimension || (EDimension = {}));
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eDimension = EDimension;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        _this.filter = {
            dimension: 3,
            order_from: 1,
            time_type: 1,
            keyword: '',
            s_time: currMonthDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: currMonthDefaultDate().End.format('yyyy-MM-dd')
        };
        return _this;
    }
    List.prototype.created = function () {
        this.service = PurchaseReportForUpperSupService.getInstance();
    };
    List.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 230;
        }, 300);
        this.getList();
    };
    List.prototype.updated = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.$refs['table'].doLayout();
        });
    };
    List.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        console.log('getList>>>');
        var loadingInstance = Loading.service({ fullscreen: true });
        this.isReady = false;
        this.service.getSummaryList(Object.assign({}, this.filter, __assign({}, pager, { sort_field: this.order ? this.order[0] : null, sort_type: this.order ? this.order[1] : null }))).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
            _this.isReady = true;
            _this.$forceUpdate();
            console.log('getList success>>>');
        }).catch(function (err) {
            _this.isReady = true;
            loadingInstance.close();
            _this.$message.error(err.message);
            _this.$forceUpdate();
            console.log('getList fail>>>');
        });
    };
    List.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        if (!filter.s_time) {
            this.$message.error('请选择开始时间');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束时间');
            return;
        }
        this.filter = filter;
        this.getList();
    };
    List.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    List.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }), { tempateType: function () {
                    var typeMap = {
                        1: 76,
                        2: 75,
                        3: 74,
                        4: 77,
                        5: 78,
                    };
                    return typeMap[this.filter.dimension];
                } }),
            components: {
                'list-header': Header
            }
        })
    ], List);
    return List;
}(Vue));
export default List;
